module.exports = __webpack_public_path__ + "media/images/3_6-68b0a540345cdbd10714c8d2b8c2046b.png";